import { createTheme } from "@mui/material/styles";
import { ThemeConfig } from "./types";
import { merge } from "lodash";

const defaultThemeConfig: ThemeConfig = {
  mode: "light",
  primaryColor: "#7b1fa2",
  secondaryColor: "#455a64",
};

export const defaultTheme = (config: ThemeConfig = defaultThemeConfig) =>
  createTheme(
    merge(
      {
        palette: {
          mode: config.mode,
          primary: {
            main: config.primaryColor,
            contrastText: "#FFFFFF",
          },
          secondary: {
            main: config.secondaryColor,
          },
        },
      },
      config?.ThemeOptions
    )
  );
